import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DataListingProviderComponent } from '../../../../shared/components/data-listing-provider/data-listing-provider.component';
import { AuthenticationGuard } from '../../../../shared/guard/authentication-guard';
import { HasUnsavedChangesGuard } from '../../../../shared/guard/has-form-changed.guard';
import { Entity, HeaderMenuType } from '../../../../shared/store/view/types';
import { ModuleId } from '../../../../shared/store/navigation/types';
import { KnownIpAddressDetailsComponent } from './known-ip-address-details/known-ip-address-details.component';
import { KnownIpAddressEditComponent } from './known-ip-address-edit/known-ip-address-edit.component';

const routes: Routes = [
  {
    path: 'Configuration/KnownIpAddresses',
    data: {
      breadcrumb: { label: ' ', alias: 'list' },
    },
    children: [
      {
        path: '',
        redirectTo: 'List',
        pathMatch: 'full',
      },
      {
        path: 'List',
        component: DataListingProviderComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Configuration,
          moduleId: ModuleId.configuration,
          entity: Entity.KnownIpAddress,
          breadcrumb: { skip: true },
        },
      },
      {
        path: 'Details/:id',
        component: KnownIpAddressDetailsComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Configuration,
          moduleId: ModuleId.configuration,
          entity: Entity.KnownIpAddress,
          breadcrumb: { label: ' ', alias: 'details' },
        },
      },
      {
        path: 'Edit/:id',
        component: KnownIpAddressEditComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Configuration,
          moduleId: ModuleId.configuration,
          entity: Entity.KnownIpAddress,
          breadcrumb: { label: ' ', alias: 'edit' },
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class KnownIpAddressRoutingModule {}
